const values = [
  {
    icon: "ri-focus-3-line",
    title: "iOS Expertise",
    desc: "Deep knowledge of the Apple ecosystem — from Swift to App Store optimization.",
  },
  {
    icon: "ri-lock-2-line",
    title: "Security First",
    desc: "Every product is built with privacy and data protection at its core.",
  },
  {
    icon: "ri-lightbulb-flash-line",
    title: "User-Centered Design",
    desc: "Intuitive interfaces crafted to deliver the smoothest possible experience.",
  },
  {
    icon: "ri-rocket-2-line",
    title: "Continuous Innovation",
    desc: "We constantly evolve our products to meet modern challenges and user needs.",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-24 md:py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Top: two columns */}
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20 mb-20">
          {/* Left: image */}
          <div className="flex-shrink-0 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-2xl overflow-hidden w-full h-72 md:h-96">
              <img
                src="https://public.readdy.ai/ai/img_res/74adbbbc6313d4f80b66c6c0a59872d9.jpg"
                alt="XEDRA d.o.o. workspace"
                className="w-full h-full object-cover object-top"
              />
              {/* Overlay label */}
              <div className="absolute bottom-4 left-4 bg-white/90 backdrop-blur-sm rounded-xl px-4 py-3">
                <p className="text-xs text-gray-500 uppercase tracking-widest">Founded in</p>
                <p className="text-xl font-semibold text-gray-900">Croatia</p>
              </div>
            </div>
          </div>

          {/* Right: text */}
          <div className="flex-1 w-full">
            <p className="text-xs uppercase tracking-widest text-gray-400 mb-3 font-medium">Who We Are</p>
            <h2 className="text-4xl md:text-5xl font-extralight text-gray-900 mb-6">
              About <span className="font-semibold">XEDRA d.o.o.</span>
            </h2>
            <p className="text-base text-gray-600 leading-relaxed mb-5">
              XEDRA d.o.o. is a Croatian software company united by a single mission: to build modern, powerful iOS applications that genuinely improve people&apos;s digital lives. Our team brings deep expertise in mobile development, cybersecurity, and system optimization.
            </p>
            <p className="text-base text-gray-600 leading-relaxed mb-5">
              From our VPN solution — designed to safeguard user privacy in an increasingly monitored internet — to our Cleaner app that restores peak device performance, every product we ship reflects our commitment to quality, reliability, and respect for the end user.
            </p>
            <p className="text-base text-gray-600 leading-relaxed">
              Headquartered in Vinkovci, Croatia, XEDRA d.o.o. operates with the precision of a specialized studio and the ambition of a global technology company. We believe great software should feel effortless — and we build accordingly.
            </p>
          </div>
        </div>

        {/* Values grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((v) => (
            <div key={v.title} className="bg-white rounded-2xl p-6 border border-gray-100">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-gray-100 mb-4">
                <i className={`${v.icon} text-xl text-gray-700`} />
              </div>
              <h4 className="text-sm font-semibold text-gray-900 mb-2">{v.title}</h4>
              <p className="text-sm text-gray-500 leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
